//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
import moment from 'dayjs'
import subLength from '@/common/library/subLength.js'
import uniIcons from "@/components/uni-icon/uni-icon.vue"
export default {
  data() {
    return {
      list: [],
      end: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        count: 0,
        name: '',
        loading: false
      }
    }
  },
  onLoad() {
    this.queryData()
  },
  onPullDownRefresh() {
    this.list = []
    this.page.currentPage = 1
    this.queryData('refresh')
  },
  onReachBottom() {
    if (this.list.length < this.page.count) {
      this.queryData()
    }
  },
  components: {
    uniLoadMore,uniIcons
  },
  methods: {
    handleClick(item) {
      uni.navigateTo({
        url: `/pages/notice/detail?id=${item.id}`
      })
    },
    queryData(status) {
      this.page.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/cms/notice/queryPage',
        data: {
          ...this.page
        }
      }).then(data => {
        this.page.count = data.count
        this.list.push.apply(this.list, this.renderData(data.data))
        if (this.list.length >= this.page.count) {
          this.end = true
        }
        this.page.currentPage += 1
        if (status === 'refresh') {
          uni.stopPullDownRefresh();
        }
        this.page.loading = false
      })
    },
    renderData(data) {
      return data.map(t => {
        t.createTime = moment(t.createTime).format('YYYY年MM月DD日 HH:MM')
        t.content = t.detail ? subLength(t.detail, 40) : ''
        return t
      })
    }
  }
}
